import * as Yup from 'yup';

export const addressSchema = Yup.object({
  address_1: Yup.string()
    .required(),
  city: Yup.string()
    .required(),
  county: Yup.string()
    .required(),
  state: Yup.string()
    .required(),
  zip: Yup.string()
    .min(5)
    .max(5)
    .required(),
});

export function addressValid(address) {
  return addressSchema.isValidSync(address);
}
